/**
 * useScheduleDraftCreateFormOptions — ScheduleDraft 创建弹窗飞机选项入口。
 *
 * 本 hook 为创建草稿弹窗提供 aircraft_scope 所需的飞机选项，并复用统一引用
 * 数据 mapper。创建弹窗因此不直接拼接 aircraft label，也不关心引用数据获取
 * 机制。
 *
 * 设计文档 → docs/10_core_contracts/12_api_v3_frontend_boundary.md
 * 骨架关联 → lib/referenceDataMappers.js (option mapper), components/ScheduleDraftCreateDialog.jsx (创建入口), hooks/queryKeys.js (引用数据 key)
 */

import { useMemo } from "react";
import { useQuery } from "react-query";
import { useAircrafts } from "../../../../hooks/useReferenceData";
import { scheduleDraftReferenceDataService } from "../services/scheduleDraftReferenceDataService";
import { mapAircraftOption } from "../lib/referenceDataMappers";
import { referenceDataQueryKeys } from "./queryKeys";

const REFERENCE_STALE_TIME = 10 * 60 * 1000;

export function useScheduleDraftCreateFormOptions(enabled = true) {
    const aircraftsQuery = useAircrafts({ enabled });
    const v1SchedulesQuery = useQuery(
        referenceDataQueryKeys.v1Schedules({ scope: "create-dialog" }),
        () => scheduleDraftReferenceDataService.getV1Schedules(),
        {
            enabled,
            staleTime: REFERENCE_STALE_TIME,
            refetchOnWindowFocus: false,
        },
    );
    const aircraftOptions = useMemo(() => aircraftsQuery.aircrafts.map(mapAircraftOption), [aircraftsQuery.aircrafts]);

    return {
        aircrafts: aircraftsQuery.aircrafts,
        aircraftOptions,
        v1Schedules: v1SchedulesQuery.data || [],
        v1SchedulesLoading: v1SchedulesQuery.isLoading || v1SchedulesQuery.isFetching,
        isLoading: aircraftsQuery.isLoading,
    };
}

export default useScheduleDraftCreateFormOptions;
